module.exports = __webpack_public_path__ + "static/img/witness-kids-6.f157d2fe.png";